import Index from "../../pages/snail/sixAnniversary/index";
import Query from "../../pages/snail/sixAnniversary/query"
import Pc from "../../pages/snail/sixAnniversary/pc";

const base = "sixAnniversary";

const routes = [{
        path: `/${base}/index`,
        name: `${base}-index`,
        component: Index
    },
    {
        path: `/${base}/enter*`,
        name: `${base}-enter`,
        component: Index
    },
    {
        path: `/${base}/query*`,
        name: `${base}-query`,
        component: Query
    },
    {
        path: `/${base}/pc`,
        name: `${base}-pc`,
        component: Pc
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/snail/sixAnniversary.js